import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import CalcSection from './CalcSection'
import CalcParagraph from './CalcParagraph'
import NavBtn from './NavBtn'
import NavBar from './NavBar'
import * as sectionConstants from './section'
import PopOver from './PopOver'
import FormattedConnectedInput from '../forms/FormattedConnectedInput'
import FormNumberTotal from '../forms/FormNumberTotal'
import * as formConstants from '../forms/form'
import ALink from './ALink'
import HelpFilter from './HelpFilter'

/**
 * Basic component for rendering Section 2 of the calculator
 */
export default class Section2 extends Component {
  /**
   * Render the component
   */
  render () {
    return (
      <CalcSection title={this.props.title}>
        <HelpFilter showLevel={[3]}>
          Now that we have the basics out of the way, let's expand a bit to
          cover the extras.
        </HelpFilter>
        <HelpFilter showLevel={[1, 2]}>
          <CalcParagraph>
            Now that we have the basics out of the way, let's expand a bit to
            cover the extras. We all enjoy things like TV, smart phones, video
            games, new clothes, dinner out, etc. We haven't accounted for any of
            these fun things in life! While people have different preferences
            there are categories that almost everyone will use throughout their
            life. The list I want you to consider is:
          </CalcParagraph>
          <ul style={sectionConstants.listStyle}>
            <li>Clothing</li>
            <li>Dining & Entertainment</li>
            <li>Digital Services</li>
            <li>Gifts</li>
          </ul>
          <CalcParagraph>
            Enter monthly estimates for what you will want to spend in
            retirement for each of these categories.
            <HelpFilter showLevel={[1]}>
              For some categories (e.g. Clothing) it may be easier to consider
              how much you will spend per year and then divide that by twelve.
              The "Digital Services" category can cover a range of products and
              services including TV, internet, phone, music and game services.
              If you captured eating out costs in the previous section, that's
              fine. The "Dining & Entertainment" category here is meant to cover
              those special occasions that aren't a part of your weekly
              routines. For example: parties, trips to the golf course, a
              special bottle of wine for guests or dinner and a movie. As
              before, don't consider inflation and don't worry about "thinking
              of everything" - it is fine to use a rough estimate. If you're
              having trouble coming up with a number, enter what you spend now.
              If you're really stuck,{' '}
              <PopOver linkText='there are a couple of U.S. averages'>
                The U.S. Department of Labor releases statistics on consumer
                spending on a regular basis.
                <ALink href='https://www.bls.gov/news.release/cesan.nr0.htm'>
                  The most recent annual release of this information is for 2015
                </ALink>
                (published August, 2016). This report doesn't capture all of the
                categories we're after but they have a couple. The average
                household spent (per month):
                <ul style={sectionConstants.listStyle}>
                  <li>
                    Clothing: $154. Note that the report specifies this category
                    as "Apparel and Services" and it is per person.
                  </li>
                  <li>
                    Dining & Entertainment: $237 Note that the report specifies
                    this category as "Entertainment" and it is per person.
                  </li>
                  <li>Digital Services: No data. </li>
                  <li>Gifts: $152</li>
                </ul>
              </PopOver>{' '}
              that may give you an idea or be used directly
            </HelpFilter>
          </CalcParagraph>
        </HelpFilter>
        <Form style={formConstants.formWrapperStyle} horizontal>
          <FormattedConnectedInput
            label={formConstants.clothesLabel}
            dollarForm
          />
          <FormattedConnectedInput
            label={formConstants.diningEntLabel}
            reduxKey={formConstants.diningEntKey}
            dollarForm
          />
          <FormattedConnectedInput
            label={formConstants.digitalSvcsLabel}
            reduxKey={formConstants.digitalSvcsKey}
            dollarForm
          />
          <FormattedConnectedInput
            label={formConstants.giftsLabel}
            dollarForm
          />
        </Form>
        <FormNumberTotal
          formKeys={formConstants.income2FormKeys}
          sectionNumber={2}
        />
        <NavBar>
          <NavBtn nextSection={1} back />
          <NavBtn nextSection={3} />
        </NavBar>
      </CalcSection>
    )
  }
}

CalcSection.propTypes = {
  title: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/sections/Section2MonthlyCosts.js